"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findDomainConfig = exports.entry_config = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
// Let's Trade
var entry_asterisk_png_1 = __importDefault(require("../../assets/backgrounds/entry_asterisk.png"));
var LTLogoWhite_png_1 = __importDefault(require("../../assets/logos/LTLogoWhite.png"));
// Chenosis
var side_image_jpg_1 = __importDefault(require("../../assets/chenosis/side-image.jpg"));
var logo_light_png_1 = __importDefault(require("../../assets/chenosis/logo-light.png"));
var logo_dark_png_1 = __importDefault(require("../../assets/chenosis/logo-dark.png"));
// Ok Franchise
var side_image_jpg_2 = __importDefault(require("../../assets/okfranchise/side-image.jpg"));
var logo_light_png_2 = __importDefault(require("../../assets/okfranchise/logo-light.png"));
var logo_dark_png_2 = __importDefault(require("../../assets/okfranchise/logo-dark.png"));
exports.entry_config = [
    // Define the domain for the themes.
    {
        domains: ["letstrade.global"],
        config: {
            slogan: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Be bold,", (0, jsx_runtime_1.jsx)("br", {}), "Have courage,", (0, jsx_runtime_1.jsx)("br", {}), "Let's Trade"] })),
            colors: {
                slogan: {
                    text: "text-[#ffffff]",
                },
                buttons: {
                    bgPrimary: "bg-[#0000E0]",
                    textPrimary: "text-[#ffffff]",
                },
                checkbox: {
                    box: "text-[#0000E0]",
                },
                link: {
                    text: "text-[#0000E0]",
                },
                radio: {
                    box: "text-[#0000E0]",
                },
            },
            logo: {
                // light: LT_Logo_Light,
                light: LTLogoWhite_png_1.default,
                dark: LTLogoWhite_png_1.default,
            },
            sideImage: entry_asterisk_png_1.default,
        },
    },
    {
        domains: ["chenosis.io"],
        config: {
            slogan: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Your products,", (0, jsx_runtime_1.jsx)("br", {}), "on-demand"] })),
            colors: {
                slogan: {
                    text: "text-[#ffffff]",
                },
                buttons: {
                    bgPrimary: "bg-[#141D26]",
                    textPrimary: "text-[#ffffff]",
                },
                checkbox: {
                    box: "text-[#141D26]",
                },
                link: {
                    text: "text-[#D8205F]",
                },
                radio: {
                    box: "text-[#141D26]",
                },
            },
            logo: {
                light: logo_light_png_1.default,
                dark: logo_dark_png_1.default,
            },
            sideImage: side_image_jpg_1.default,
        },
    },
    {
        domains: ["okfranchise.co.za"],
        config: {
            slogan: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Owners you can count on!" }),
            colors: {
                slogan: {
                    text: "text-[#ffffff]",
                },
                buttons: {
                    bgPrimary: "bg-[#000000]",
                    textPrimary: "text-[#ffffff]",
                },
                checkbox: {
                    box: "text-[#0000E0]",
                },
                link: {
                    text: "text-[#0000E0]",
                },
                radio: {
                    box: "text-[#0000E0]",
                },
                background: {
                    bgPrimary: "bg-[#e1e1e1]",
                },
                sidebar: {
                    bgPrimary: "bg-[#f6f6f6]",
                    textPrimary: "text-[#000000]",
                    border: "border-[#000000]",
                },
            },
            logo: {
                light: logo_light_png_2.default,
                dark: logo_dark_png_2.default,
            },
            sideImage: side_image_jpg_2.default,
        },
    },
];
function findDomainConfig() {
    var domain = window.location.host;
    console.log("domain", domain);
    // eg: domain = "console.letstrade.global"
    // eg: c.domains = [ "letstrade.global" ]
    var conf = exports.entry_config.find(function (c) { return c.domains.some(function (d) { return domain.includes(d); }); });
    if (!conf) {
        conf = exports.entry_config[0]; // Default to Let's Trade.
    }
    console.log("conf", conf);
    return conf;
}
exports.findDomainConfig = findDomainConfig;
